<!--
  弹窗字段行：左侧 label（宽度默认由 UiDialogFields 统一测量；可传 label-width 覆盖）+ 右侧内容插槽
-->
<script setup lang="ts">
import { computed } from "vue";

defineOptions({ name: "UiDialogField" });

const props = withDefaults(
    defineProps<{
        label?: string;
        required?: boolean;
        /** 通栏（占满当前网格全部列；优先于 span） */
        full?: boolean;
        /**
         * 跨列数（默认 1）。例如三列网格里占两列：`:span="2"`。
         * 不超过当前网格列数；`full` 时忽略。
         */
        span?: number;
        /**
         * 单独指定本字段 label 宽（如 `40` / `"40px"`），覆盖组内统一测量。
         * 仅特例使用；同列对齐仍优先交给 UiDialogFields 测量。
         */
        labelWidth?: number | string;
    }>(),
    {
        label: "",
        required: false,
        full: false,
        span: 1,
        labelWidth: undefined,
    },
);

function resolveLabelWidthCss(value: number | string | undefined): string | undefined {
    if (value == null || value === "") return undefined;
    if (typeof value === "number" && Number.isFinite(value)) return `${value}px`;
    const raw = String(value).trim();
    if (!raw) return undefined;
    if (/^\d+(\.\d+)?$/.test(raw)) return `${raw}px`;
    return raw;
}

const rootClass = computed(() => {
    if (props.full) return { "ui-dialog-field--full": true };
    const n = Math.floor(Number(props.span));
    if (Number.isFinite(n) && n >= 2) {
        return { [`ui-dialog-field--span-${Math.min(n, 5)}`]: true };
    }
    return {};
});

const rootStyle = computed(() => {
    const width = resolveLabelWidthCss(props.labelWidth);
    return width ? ({ "--dialog-label-width": width } as Record<string, string>) : undefined;
});
</script>

<template>
    <div class="ui-dialog-field" :class="rootClass" :style="rootStyle" data-ui-dialog-field :data-label-width-fixed="labelWidth != null && labelWidth !== '' ? '1' : undefined">
        <span v-if="label || $slots.label" class="ui-dialog-field__label" :class="{ 'is-required': required }" data-ui-dialog-field-label>
            <slot name="label">{{ label }}</slot>
        </span>
        <div class="ui-dialog-field__value">
            <slot />
        </div>
    </div>
</template>
